import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'page-section',
  templateUrl: './page-section.component.html',
  styleUrls: ['./page-section.component.scss']
})
export class PageSectionComponent implements OnInit {

  @Input() sectionTitle: string;

  constructor() { }

  ngOnInit() {
  }

}
